import { LimitTypeName } from "../../../../graphql/generated.ts";

export const LimitTypeNameOptions = {
  [LimitTypeName.LimitRequested]: "Limit Request",
  [LimitTypeName.CuApproved]: "CU Approved",
  [LimitTypeName.RrApproved]: "RR Approved",
  [LimitTypeName.RmonCcApproved]: "Rmon/Committee Approved",
  [LimitTypeName.LimitActive]: "Limit Active",
};
